import React from 'react';
import AdminLoginComponent from '../components/admin/login/AdminLogin';

const AdminLogin = () => {
    return (
        <AdminLoginComponent />
    );
};

export default AdminLogin;